import { render, staticRenderFns } from "./ModelActor.vue?vue&type=template&id=c5d4cdcc&scoped=true"
import script from "./ModelActor.vue?vue&type=script&lang=js"
export * from "./ModelActor.vue?vue&type=script&lang=js"
import style0 from "./ModelActor.vue?vue&type=style&index=0&id=c5d4cdcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d4cdcc",
  null
  
)

export default component.exports